import React, { useState } from "react";
import allApi from "./../data/allApi";
import Modal from "./Modal";

const All = () => {
  const [psdData, setPsdData] = useState(allApi);

  const [modal, setModal] = useState(false);
  const [tempdata, setTempdata] = useState({});
  const modalBtn = (curr) => {
      setTempdata({...curr});
      return setModal(true);
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-5">
          <div className="col-lg-10 col-12 mx-auto">
            <div className="card-columns">

              {/* <div className="card">
                <div className="hovereffect">
                  <img
                    className="img-responsive card-img-top"
                    src="https://static.independent.co.uk/2021/03/15/17/newFile-5.jpg?width=982&height=726&auto=webp&quality=7"
                    alt=""
                  />
                  <div className="overlay">
                    <h2>ES6-react concept 02-03</h2>
                    <p>
                      <a
                        href="https://es6-react-responsive-cart-concept.netlify.app/"
                        target="_blank"
                      >
                        Visit Site
                      </a>
                    </p>
                  </div>
                </div>
              </div> */}

              {psdData.map((curr) => {
                return (
                  <>
                    <div className="card" key={curr.id}>
                      <div className="hovereffect">
                        <img
                          className="img-responsive card-img-top"
                          src={curr.img}
                          alt=""
                        />
                        <div className="overlay">
                          <button className="overlyBtn" onClick={() => modalBtn(curr)}>View Details</button>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
            {
                modal === true ? <Modal data={tempdata} hide={() => setModal(false)}/> : ''
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default All;
